import React from 'react';
import { motion } from 'framer-motion';
import { FiStar } from 'react-icons/fi';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Carlos Silva',
      role: 'Cliente',
      image: '👨‍💼',
      rating: 5,
      text: 'A melhor experiência de IPTV que já tive. Qualidade impecável e suporte excepcional. Recomendo para todos!',
    },
    {
      name: 'Maria Santos',
      role: 'Cliente',
      image: '👩‍🎨',
      rating: 5,
      text: 'Uso há mais de 6 meses e nunca tive problemas. A interface é linda e muito fácil de usar. Perfeito!',
    },
    {
      name: 'João Oliveira',
      role: 'Cliente',
      image: '👨‍💻',
      rating: 5,
      text: 'Como desenvolvedor, aprecio a qualidade técnica. Streaming estável, sem buffering. Excelente trabalho!',
    },
    {
      name: 'Ana Costa',
      role: 'Cliente',
      image: '👩‍🏫',
      rating: 5,
      text: 'Minha família adora! Temos 3 TVs e todos conseguem assistir simultaneamente sem problemas. Incrível!',
    },
    {
      name: 'Pedro Alves',
      role: 'Cliente',
      image: '🏃‍♂️',
      rating: 5,
      text: 'Os canais esportivos são perfeitos. Nunca perco um jogo importante. A qualidade 4K é impressionante!',
    },
    {
      name: 'Julia Ferreira',
      role: 'Cliente',
      image: '👩‍⚕️',
      rating: 5,
      text: 'Após um dia longo de trabalho, é ótimo ter acesso a tanto conteúdo de qualidade. Vale cada centavo!',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section className="testimonials">
      <div className="testimonials-container">
        <motion.div
          className="testimonials-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="section-badge">Depoimentos</div>
          <h2 className="section-title">
            O Que Nossos Clientes
            <span className="gradient-text"> Estão Dizendo</span>
          </h2>
          <p className="section-description">
            Mais de 5.000 usuários satisfeitos em todo o Brasil confiam no CSG TV.
          </p>
        </motion.div>

        <motion.div
          className="testimonials-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              className="testimonial-card"
              variants={cardVariants}
              whileHover={{ y: -5, scale: 1.02 }}
              transition={{ duration: 0.3 }}
            >
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FiStar key={i} className="star-icon" />
                ))}
              </div>

              <p className="testimonial-text">"{testimonial.text}"</p>

              <div className="testimonial-author">
                <div className="author-avatar">{testimonial.image}</div>
                <div className="author-info">
                  <div className="author-name">{testimonial.name}</div>
                  <div className="author-role">{testimonial.role}</div>
                </div>
              </div>

              <div className="testimonial-quote">"</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;

